'use client';

import React__default from 'react';
import { TitleH3 } from './AttachName.css.js';

var CHARACTER_LENGTH = 10.5; // Assume the average length of a character is 10.5px
var DEFAULT_MIN_WIDTH = 25; // Default minimum width for the extension (.pdf = 25px)
// Split file name and extension
var splitFileExtension = function (fileName, extension) {
    var lastDotIndex = fileName.lastIndexOf('.');
    // If there's no dot in the file name, assume no extension
    if (lastDotIndex === -1) {
        return [fileName, extension];
    }
    var name = fileName.slice(0, lastDotIndex);
    var extensionName = fileName.slice(lastDotIndex);
    return [name, extensionName];
};
var AttachName = function (props) {
    var _a = splitFileExtension(props.fileName), fileName = _a[0], fileExtension = _a[1];
    var minWidthExtension = fileExtension ? (fileExtension === null || fileExtension === void 0 ? void 0 : fileExtension.length) * CHARACTER_LENGTH : DEFAULT_MIN_WIDTH;
    return React__default.createElement(TitleH3, { "data-filename": fileName, "data-extension": fileExtension, minWidth: minWidthExtension });
};

export { CHARACTER_LENGTH, DEFAULT_MIN_WIDTH, AttachName as default, splitFileExtension };
//# sourceMappingURL=index.js.map
